import { useState, useEffect, useRef } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import { OtpServices } from "../services/OtpServices";
import { HospitalServices } from "../services/HospitalServices";
import { CircularProgress } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { logOut } from "../config/user";
import CustomPagination from "../utils/paginationUtils";
import SearchIcon from "@mui/icons-material/Search";
import Select from "react-select";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import "./GetTmsUserVersionsList.scss";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";

const GetTmsUserVersionsList = () => {
  const [otpLogsList, setotpLogsList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [appType, setAppType] = useState("ANDROIDAPP");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(15);
  let searchTimeRef = useRef();
  const { newOtpMessage } = useSelector((store) => store.notificationReducer);

  const appTypeOptions = [
    { value: "ANDROIDAPP", label: "Android" },
    { value: "DMAPP", label: "DMApp" },
    { value: "IOSApp", label: "iOSApp" },
  ];

  const handleSearch = (e) => {
    //debouncing structure
    if (searchTimeRef.current) {
      clearInterval(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
    }, 500);
  };

  const getDate = (dateString) => {
    const date = new Date(dateString);

    // Format the date as DD/MM/YYYY HH:MM
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const getUserVersions = async () => {
    try {
      const res = await OtpServices.getDmappVersionsList(
        page,
        limit,
        searchKey,
        appType
      );

      console.log(res.data.record);
      setotpLogsList(res.data.record);
      setTotalPages(res.data.totalPages);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const getUserVersionsCount = async () => {
    try {
      const res = await OtpServices.getUsersCount();
      console.log(res.data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  useEffect(() => {
    getUserVersionsCount();
  });

  useEffect(() => {
    getUserVersions();
  }, [page, searchKey, appType, newOtpMessage]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="tms-otp-box">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Dashboard &nbsp; &nbsp;/ &nbsp; &nbsp; User Insights
      </span>
      <div className="heading">
        User Insights
        <div className="text-[16px] flex items-center gap-4">
          <Select
            name="appType"
            isClearable
            options={appTypeOptions}
            onChange={(item) => {
              setPage(1);
              item ? setAppType(item.value) : setAppType("");
            }}
            value={appTypeOptions.find((item) => item.value === appType)}
            placeholder="FILTER BY APP TYPE"
            className="min-w-[200px]"
          />
          <div className="flex gap-2 items-center py-2 px-4 bg-white rounded-[8px] border border-gray-300">
            <SearchIcon className="text-xl" />
            <input
              type="text"
              className="outline-none border-none w-full"
              placeholder="Search by Mobile Number"
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          border: "1px solid #E7E7E7",
          marginBottom: "20px",
        }}
      />
      {isLoading ? (
        <div className="flex justify-center">
          <CircularProgress />
        </div>
      ) : (
        <div>
          <div className={`grid grid-cols-6  text-[#797979] text-[18px] px-8`}>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                User Mobile Number
              </div>{" "}
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">App Type</div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                App Version
              </div>{" "}
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Mobile Version
              </div>{" "}
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Device Name
              </div>{" "}
            </div>

            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Updated Time
              </div>
            </div>
          </div>
          {otpLogsList && otpLogsList.length > 0 ? (
            otpLogsList?.map((otp, idx) => {
              return (
                <div
                  key={idx}
                  className={`py-6 px-8 rounded-[16px] ${
                    idx % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"
                  }`}
                >
                  <div
                    className={`grid grid-cols-6  text-[#797979] text-[18px] `}
                  >
                    <div>
                      <div>{otp?.mobileNo || "--"}</div>
                    </div>
                    <div>
                      <div>{otp?.appType || "--"}</div>
                    </div>
                    <div>
                      <div>{otp?.latestVersion || "--"}</div>
                    </div>
                    <div>
                      <div className="flex items-center gap-1">
                        {otp?.deviceVersion || "--"}{" "}
                      </div>
                    </div>
                    <div>
                      <div>{otp?.deviceName}</div>
                    </div>

                    <div>
                      <div>
                        {otp?.updatedAt ? getDate(otp?.updatedAt) : "--"}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-xl flex items-center justify-center mt-5 font-semibold h-[300px]">
              No Data Found
            </div>
          )}
        </div>
      )}

      <div className="flex justify-center items-center mt-3">
        <CustomPagination
          totalPages={totalPages}
          page={page}
          setPage={setPage}
        />
      </div>
    </div>
  );
};

export default GetTmsUserVersionsList;
